import { Component, computed, input } from '@angular/core';

import { IconComponent } from './icon.component';
import type { InputSignal, Signal } from '@angular/core';

@Component({
  selector: 'td-wb-icon-flag',
  templateUrl: './icon-flag.component.html',
  styleUrls: ['./icon-flag.component.scss'],
  imports: [IconComponent]
})
export class IconFlagComponent {
  readonly value: InputSignal<string> = input.required<string>();
  readonly size: InputSignal<string> = input<string>('16x11');
  readonly ariaLabel: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'aria-label' });
  readonly ariaLabelledBy: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'aria-labelledby' });
  readonly disabled: InputSignal<boolean> = input<boolean>(false);

  readonly validValue: Signal<boolean> = computed(() => {
    const v = this.value();
    return v !== undefined && v !== null && v.trim() !== '';
  });

  readonly iconId: Signal<string> = computed(() => {
    const suffix = this.disabled() ? '--disabled' : '';
    const currency = this.translateMarketToCurrency(this.value());
    return `flag-${currency}${suffix}`;
  });

  readonly computedAriaLabel: Signal<string | null> = computed(() => {
    if (this.validValue()) {
      const vhSuffix = this.disabled() ? ' disabled' : '';
      return `${this.value()}${vhSuffix}`;
    }
    return null;
  });

  private translateMarketToCurrency(value: string): string {
    if (value !== undefined) {
      const result = value.toLowerCase();
      if (result === 'ca' || result === 'us') {
        return `${result}d`;
      }
      return result;
    }
    return value;
  }

}
